import { RequestDataContext } from '../../context/RequestDataContext';
import { useContext } from 'react';

// Selector hook for reading requestData from the nearest RequestDataProvider
export const useRequestDataContext = () => {
  const requestData = useContext(RequestDataContext);

  if (!requestData.isProvided) {
    throw new Error(
      'useRequestDataContext must be used within a RequestDataProvider'
    );
  }

  return requestData.requestData;
};
